<template>
  <button class="scroll-to-top">SCROLL TO TOP</button>
  <div class="hero__wrapper">
    <a class="hero__a--drinkaware" href="https://www.drinkaware.ie" target="_blank" style="z-index: 1000;"><img class="hero__img--drinkaware" src="hero/drinkaware.png"></a>
    <div class="hero__tabs">
      <div class="hero__tab hero__tab--1">
        <div class="hero__tab-copy">Raspberry<br> Crush</div>
        <div class="hero__tab-icon hero__tab-icon--1"></div>
      </div>
      <div class="hero__tab hero__tab--2">
        <div class="hero__tab-copy">Mango &amp;<br> Passionfruit</div>
        <div class="hero__tab-icon hero__tab-icon--2"></div>
      </div>
      <div class="hero__tab hero__tab--3">
        <div class="hero__tab-copy">Berry Burst</div>
        <div class="hero__tab-icon hero__tab-icon--3"></div>
      </div>
      <div class="hero__tab hero__tab--4">
        <div class="hero__tab-copy">SMIRNOFF<br> NO.21</div>
        <div class="hero__tab-icon hero__tab-icon--4"></div>
      </div>
      
      
    </div>
    <img class="hero__logo hero__logo--1" src="hero/logo.png">
    <img class="hero__logo hero__logo--2" src="hero/logo--red.png">
    <div class="hero__copy">
      <div class="hero__copy-row"><span class="hero__span--sans">NEW</span> <span>Smirnoff</span></div> <div class="hero__copy-row"><span>Raspberry</span> <span>Crush</span></div>
    </div>
    
    <img class="hero__img--prod hero__img--prod--1 hero__img--prod--1--active" src="hero/raspberry--active.png">
    <img class="hero__img--prod hero__img--prod--1 hero__img--prod--1--inactive" src="hero/raspberry--inactive.png">
    <img class="hero__img--prod hero__img--prod--2 hero__img--prod--2--active" src="hero/passionfruit--active.png">
    <img class="hero__img--prod hero__img--prod--2 hero__img--prod--2--inactive" src="hero/passionfruit--inactive.png">
    <img class="hero__img--prod hero__img--prod--3 hero__img--prod--3--active" src="hero/berry--active.png">
    <img class="hero__img--prod hero__img--prod--3 hero__img--prod--3--inactive" src="hero/berry--inactive.png">
    <img class="hero__img--prod hero__img--prod--4 hero__img--prod--4--active" src="hero/21--active.png">
    <img class="hero__img--prod hero__img--prod--4 hero__img--prod--4--inactive" src="hero/21--inactive.png">
    
    <div class="hero hero--1"></div>
    <div class="hero hero--2"></div>
    <div class="hero hero--3"></div>
    <div class="hero hero--4"></div>
  </div>
</template>

<script setup>

import dataModel from '../js/model.js';
import gsap from "gsap";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1"
  },
});
$(document).ready(function() {
  
  gsap.set('.hero__tab', {
    x: -140
  })
  $('.hero--1').css({
    background: 'url(hero/bg--raspberry.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  })
  $('.hero--2').css({
    background: 'url(hero/bg--passionfruit.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  })
  $('.hero--3').css({
    background: 'url(hero/bg--berry.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  })
  $('.hero--4').css({
    background: 'url(hero/bg--21.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  })
  var heroElemPositioning = () => {
    gsap.set('.hero__img--prod', {
      height: () => {
        if(window.innerWidth >= 320 && window.innerWidth < 350) {
          return 400
        } else if(window.innerWidth >= 321 && window.innerWidth < 600) {
          return 500
        } else {
          if(window.innerHeight < 700) {
            return 500
          } else {
            return window.innerHeight/1.5
          }
          
        }
        
      }
    })
  };

  $('.hero__tab').on('click', function() {
    if($(this).hasClass('hero__tab--1')) {
      $('.api__navbar-option[data-id="1"]').click();
    } else if($(this).hasClass('hero__tab--2')) {
      $('.api__navbar-option[data-id="2"]').click();
    } else if($(this).hasClass('hero__tab--3')) {
      $('.api__navbar-option[data-id="3"]').click();
    } else if($(this).hasClass('hero__tab--4')) {
      $('.api__navbar-option[data-id="4"]').click();
    } else {
      $('.api__navbar-option[data-id="1"]').click();
    }
  })


  
  //resize positioning
  $(window).resize(function() {
    heroElemPositioning();
  });

  heroElemPositioning();

  (function (factory) { if (typeof define === "function" && define.amd) { define(factory) } else if (typeof module !== "undefined" && module.exports) { module.exports = factory() } else { window.enterView = factory.call(this) } })((() => { const lib = ({ selector: selector, enter: enter = (() => { }), exit: exit = (() => { }), progress: progress = (() => { }), offset: offset = 0, once: once = false }) => { let raf = null; let ticking = false; let elements = []; let height = 0; function setupRaf() { raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) { return setTimeout(callback, 1e3 / 60) } } function getOffsetHeight() { if (offset && typeof offset === "number") { const fraction = Math.min(Math.max(0, offset), 1); return height - fraction * height } return height } function updateHeight() { const cH = document.documentElement.clientHeight; const wH = window.innerHeight || 0; height = Math.max(cH, wH) } function updateScroll() { ticking = false; const targetFromTop = getOffsetHeight(); elements = elements.filter((el => { const { top: top, bottom: bottom, height: height } = el.getBoundingClientRect(); const entered = top < targetFromTop; const exited = bottom < targetFromTop; if (entered && !el.__ev_entered) { enter(el); el.__ev_progress = 0; progress(el, el.__ev_progress); if (once) return false } else if (!entered && el.__ev_entered) { el.__ev_progress = 0; progress(el, el.__ev_progress); exit(el) } if (entered && !exited) { const delta = (targetFromTop - top) / height; el.__ev_progress = Math.min(1, Math.max(0, delta)); progress(el, el.__ev_progress) } if (entered && exited && el.__ev_progress !== 1) { el.__ev_progress = 1; progress(el, el.__ev_progress) } el.__ev_entered = entered; return true })); if (!elements.length) { window.removeEventListener("scroll", onScroll, true); window.removeEventListener("resize", onResize, true); window.removeEventListener("load", onLoad, true) } } function onScroll() { if (!ticking) { ticking = true; raf(updateScroll) } } function onResize() { updateHeight(); updateScroll() } function onLoad() { updateHeight(); updateScroll() } function selectionToArray(selection) { const len = selection.length; const result = []; for (let i = 0; i < len; i += 1) { result.push(selection[i]) } return result } function selectAll(selector, parent = document) { if (typeof selector === "string") { return selectionToArray(parent.querySelectorAll(selector)) } else if (selector instanceof NodeList) { return selectionToArray(selector) } else if (selector instanceof Array) { return selector } } function setupElements() { elements = selectAll(selector) } function setupEvents() { window.addEventListener("resize", onResize, true); window.addEventListener("scroll", onScroll, true); window.addEventListener("load", onLoad, true); onResize() } function init() { if (!selector) { console.error("must pass a selector"); return false } setupElements(); if (!elements || !elements.length) { console.error("no selector elements found"); return false } setupRaf(); setupEvents(); updateScroll() } init() }; return lib }));

  if(window.innerWidth > 760) {
    enterView({
        selector: '.component__carousel--1',
        enter: function (el) {
            gsap.fromTo('.scroll-to-top', { opacity: 0 }, { opacity: 1, duration: .5 });
        },
        exit: function (el) {
            gsap.fromTo('.scroll-to-top', { opacity: 1 }, { opacity: 0, duration: .5 });
        },
        offset: 0,
        once: false
    });
} else {
    enterView({
        selector: '.component__carousel--1',
        enter: function (el) {
            gsap.fromTo('.scroll-to-top', { opacity: 0 }, { opacity: 1, duration: .5 });
        },
        exit: function (el) {
            gsap.fromTo('.scroll-to-top', { opacity: 1 }, { opacity: 0, duration: .5 });
        },
        offset: 0,
        once: false
    });
}
  
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.scroll-to-top {
    @include flexbox();
    @include justify-content(center);
    @include align-items(center);
    background: #000;
    color: #fff;
    border-radius: 50px;
    font-size: 12px;
    font-family: 'Mark Pro', sans-serif;
    opacity: 0;
    position: fixed;
    left: calc(50% - 75px);
    letter-spacing: 1px;
    bottom: 20px;
    height: 40px;
    padding-top: 0px;
    width: 150px;
    z-index: 101;
    &:hover {
        cursor: pointer;
    }
    @media (max-width: 760px) {
        //display: none;
        bottom: 160px;
    }
}
.hero__a--drinkaware {
  position: absolute;
  left: 20px;
  top: 20px;
  @media screen and (max-width: 600px) {
    left: 5px;
    top: 5px;
  }
}
.hero__img--drinkaware {
  position: relative;
  width: 150px;
  @media screen and (max-width: 600px) {
    width: 100px;
  }
}
.hero__wrapper {
  width: 100%;
  height: calc(100% - 100px);
  max-height: 800px;
  min-height: 700px;
  overflow: hidden;
  position: relative;
  &::after {
    content: '';
    height: 10px;
    width: 100% !important;
    min-width: 100vw !important;
    position: absolute;
    left:0px;
    bottom: 0px;
    border: 10px solid;
    border-image-slice: 1;
    border-width: 10px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-image-source: linear-gradient(to left, #f3d49d, #a8762c, #f3d49d);
    z-index: 1;
  }
  @media screen and (max-width: 600px) {
    min-height: 0px;
  }
}
.hero__tabs {
  @include flexbox();
  @include justify-content(center);
  @include align-items(flex-start);
  @include flex-direction(column);
  height: 100%;
  position: absolute;
  width: 100%;
  @media screen and (max-width: 600px) {
    @include justify-content(flex-end);
    padding-bottom: 60px;
  }
}
.hero__tab {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  @include flex-direction(row);
  background: #ffffff;
  border-radius: 0px 30px 30px 0px;
  height: 50px;
  overflow: hidden;
  position: relative;
  width: 200px;

  &--1 {
    background: #f00091;
  }
  &--2 {
    background: #fab80e;
  }
  &--3 {
    background: #422a80;
  }
  &--4 {
    background: #bc0e2d;
  }
}
.hero__tab-copy {
  @include flex(1);
  color: #ffffff;
  font-family: 'Mark Pro', sans-serif;
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
}
.hero__tab-icon {
  height: 50px;
  width: 60px;

  &:hover {
    cursor: pointer !important;
  }

  &--1 {
    background: url('/public/hero/icon--1.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80% auto;
  }
  &--2 {
    background: url('/public/hero/icon--2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80% auto;
  }
  &--3 {
    background: url('/public/hero/icon--3.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80% auto;
  }
  &--4 {
    background: url('/public/hero/icon--4.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80% auto;
  }
}
.hero {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  background-size: cover;
  height: 100%;
  position: relative;
  width: 100%;  
}
.hero--1 {
  left: 0px;
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  z-index: -1;
}
.hero--2 {
  left: 0px;
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  z-index: -1;
}
.hero--3 {
  left: 0px;
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  z-index: -1;
}
.hero--4 {
  left: 0px;
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100%;
  z-index: -1;
}
.hero__img--prod {
  max-height: 600px;
  position: absolute;

  &--1 {
    bottom: -15%;
    left: 25%;
    @media screen and (max-width: 1150px) {
      bottom: -14%;
      left: 20%;
    }
    @media screen and (max-width: 770px) {
      bottom: -20%;
      left: 15%;
    }
    @media screen and (max-width: 600px) {
      bottom: -5%;
      left: 50%;
    }
  }
  &--2 {
    bottom: -12%;
    left: 40%;
    @media screen and (max-width: 1150px) {
      bottom: -12%;
      left: 38%;
    }
    @media screen and (max-width: 770px) {
      bottom: -15%;
      left: 32%;
    }
    @media screen and (max-width: 600px) {
      bottom: -5%;
      left: 50%;
    }
  }
  &--3 {
    bottom: -9%;
    left: 55%;
    @media screen and (max-width: 1150px) {
      bottom: -10%;
      left: 56%;
    }
    @media screen and (max-width: 770px) {
      bottom: -10%;
      left: 49%;
    }
    @media screen and (max-width: 600px) {
      bottom: -5%;
      left: 50%;
    }
  }

  &--4 {
    bottom: -6%;
    left: 70%;
    @media screen and (max-width: 1150px) {
      bottom: -8%;
      left: 74%;
    }
    @media screen and (max-width: 770px) {
      bottom: -5%;
      left: 66%;
    }
    @media screen and (max-width: 600px) {
      bottom: -5%;
      left: 50%;
    }
  }
}
.hero__logo {
  left: calc(50% - 100px);
  opacity: 0;
  position: absolute;
  top: 20px;
  width: 200px;
  @media screen and (max-width: 600px) {
    left: calc(50% - 75px);
    width: 120px;
  }
}
.hero__copy {
  color: #ffffff;
  font-size: 40px;
  line-height: 40px;
  font-style: italic;
  margin-top: 150px;
  @media screen and (max-width: 600px) {
    margin-top: 110px;
  }
  @media screen and (max-width: 321px) {
    margin-top: 100px;
  }

  & span {
    @media screen and (max-width: 600px) {
      display: block;
      font-size: 9vw;
      line-height: 9vw;
      margin-left: -150px;
    }
    @media screen and (max-width: 321px) {
      font-size: 7vw;
      line-height: 7vw;
  }
  }
}
.hero__span--sans {
  font-family: 'Mark Pro', sans-serif;
  font-weight: bold;
  font-style: initial;
}
</style>